/* eslint-disable */
export enum TranslationModuleActionTypes {
  RESET_SELECTED = "@@TranslationModule/RESET_SELECTED",
  ADD_EMAIL = "@@TranslationModule/ADD_EMAIL",
  ADD_SMS = "@@TranslationModule/ADD_SMS",
  SET_MODAL_STATE = "@@TranslationModule/SET_MODAL_STATE"
}
